import { colors, fonts } from '@grupoboticario/flora-tokens/dist/gbInstitucional/web/ds'

export const gbInstitucional = {
  colors,
  fonts,
}
